var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "top-box" },
        [
          _c(
            "vxe-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "ADD",
                  expression: "`ADD`",
                },
              ],
              staticStyle: { "margin-bottom": "10px" },
              attrs: { status: "primary" },
              on: { click: _vm.addAddress },
            },
            [_vm._v("添加地址")]
          ),
          _c("div", [
            _c("div", { staticClass: "search-box" }, [
              _c(
                "div",
                [
                  _c("span", [_vm._v("收货人")]),
                  _c("a-input", {
                    staticStyle: { width: "130px" },
                    attrs: { clearable: "", placeholder: "请输入关键字搜索" },
                    model: {
                      value: _vm.serachParams.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.serachParams, "name", $$v)
                      },
                      expression: "serachParams.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", [_vm._v("电话")]),
                  _c("a-input", {
                    staticStyle: { width: "130px" },
                    attrs: { clearable: "", placeholder: "请输入关键字搜索" },
                    model: {
                      value: _vm.serachParams.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.serachParams, "phone", $$v)
                      },
                      expression: "serachParams.phone",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", [_vm._v("地址")]),
                  _c("a-input", {
                    staticStyle: { width: "130px" },
                    attrs: { clearable: "", placeholder: "请输入关键字搜索" },
                    model: {
                      value: _vm.serachParams.address,
                      callback: function ($$v) {
                        _vm.$set(_vm.serachParams, "address", $$v)
                      },
                      expression: "serachParams.address",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("span", [_vm._v("创建人")]),
                  _c("a-input", {
                    staticStyle: { width: "130px" },
                    attrs: { clearable: "", placeholder: "请输入关键字搜索" },
                    model: {
                      value: _vm.serachParams.createUser,
                      callback: function ($$v) {
                        _vm.$set(_vm.serachParams, "createUser", $$v)
                      },
                      expression: "serachParams.createUser",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-left": "10px" } },
                [
                  _c(
                    "vxe-button",
                    {
                      attrs: { status: "primary" },
                      on: { click: _vm.getList },
                    },
                    [_vm._v("搜索")]
                  ),
                  _c("vxe-button", { on: { click: _vm.resetSearch } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          ref: "xTable",
          staticClass: "mytable-scrollbar",
          attrs: {
            loading: _vm.listLoading,
            align: "center",
            "max-height":
              _vm.$store.state.app.height - 130 < 360
                ? 360
                : _vm.$store.state.app.height - 130,
            border: "",
            "show-header-overflow": "",
            "show-overflow": "",
            "column-config": { resizable: true },
            stripe: "",
            round: "",
            "scroll-y": { enabled: false },
            "row-config": { isHover: true },
            data: _vm.addresses,
          },
        },
        [
          _vm._l(_vm.columns, function (item) {
            return _c("vxe-column", {
              key: item.key,
              attrs: { field: item.key, title: item.title, width: item.width },
            })
          }),
          _c("vxe-column", {
            attrs: { title: "创建人", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [_c("div", [_vm._v(_vm._s(row.userNo))])]
                },
              },
            ]),
          }),
          _c("vxe-column", {
            attrs: { title: "操作", width: "200" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  var row = ref.row
                  return [
                    _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "UPDATE",
                            expression: "`UPDATE`",
                          },
                        ],
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.editAddress(row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "a-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "DELETE",
                            expression: "`DELETE`",
                          },
                        ],
                        attrs: { type: "link" },
                        on: {
                          click: function ($event) {
                            return _vm.deleteAddress(row.id)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
      _c("vxe-pager", {
        attrs: {
          "current-page": _vm.serachParams.pageNum,
          "page-size": _vm.serachParams.pageSize,
          total: _vm.total,
          layouts: [
            "PrevPage",
            "JumpNumber",
            "NextPage",
            "FullJump",
            "Sizes",
            "Total",
          ],
        },
        on: { "page-change": _vm.changePage },
      }),
      _c("address-modal", {
        ref: "addressModalRef",
        on: { updateList: _vm.getList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }